export default "__VITE_ASSET__BbDpyyL4__"